"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maketGetProductRecentlyViewedState = void 0;
const reselect_1 = require("reselect");
const getProductRecentlyViewed = (state) => state.productRecentlyViewed;
const maketGetProductRecentlyViewedState = () => (0, reselect_1.createSelector)(getProductRecentlyViewed, products => products);
exports.maketGetProductRecentlyViewedState = maketGetProductRecentlyViewedState;
